import _ from 'lodash';
import immutable from 'object-path-immutable';

import * as types from '../constants/actionTypes';

export const defaultState = {
  profile: {
    fields: {
      profileType: undefined,
      documents: [],
    },
  },
  rating: {
    fields: {},
  },
  ratingSelf: {
    fields: {},
  },
  validation: {
    profile: {
      fields: {},
    },
    rating: {
      fields: {},
    },
    ratingSelf: {
      fields: {},
    },
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.UPDATE_FIELD:
      return immutable.set(state, `${action.form}.fields.${action.field}`, action.value);

    case types.ADD_TO_GROUP: {
      return immutable.push(state, `profile.fields.${action.groupName}`, action.record);
    }

    case types.EDIT_IN_GROUP:
      return immutable.set(state, `profile.fields.${action.groupName}.${action.recordIndex}`, action.updatedRecord);

    case types.REMOVE_FROM_GROUP:
      return immutable.del(state, `profile.fields.${action.groupName}.${action.recordIndex}`);

    case types.HYDRATE_FORM:
      return immutable.set(state, `${action.form}.fields`, action.values);

    case types.CLEAR_FORM:
      return immutable.set(state, action.form, defaultState[action.form]);

    case types.FETCH_PROFILE_LOADING:
      return immutable.set(state, 'profile.loading', true);

    case types.FETCH_PROFILE_SUCCESS: {
      return immutable(state)
        .set('profile.fields', action.profile)
        .set('profile.loading', false)
        .value();
    }

    case types.FETCH_PROFILE_ERROR:
      return immutable.set(state, 'profile.loading', false);

      /* *********************************************************************************************
    Rating - Self
    ********************************************************************************************* */

    case types.RATING_SELF_UPDATE_FIELD:
      return immutable.set(state, action.field, action.text);

    case types.RATING_SELF_REMOVE_FIELD:
      return immutable.del(state, action.field);

    case types.RATING_SELF_REMOVE_NON_HEADER_FIELDS: {
      const headerFields = [
        'driverName',
        'series',
        'track',
        'trackCharacteristics',
        'teamName',
        'crewChiefName',
        'spotterName',
        'date',
      ];
      const headerState = _.pick(state.ratingSelf.fields, headerFields);
      return immutable.set(state, 'ratingSelf.fields', headerState);
    }

    case types.RATING_SELF_REMOVE_ENGINE_FIELDS: {
      const fields = _.map(state, (item, key) => (_.startsWith(key, 'engine') ? key : false)).filter(Boolean);
      return Object.assign({}, _.omit(state, fields));
    }

    /* *********************************************************************************************
    Rating - Driver
    ********************************************************************************************* */

    case types.RATING_UPDATE_FIELD:
      return immutable.set(state, action.field, action.text);

    case types.RATING_REMOVE_FIELD:
      return immutable.del(state, action.field);

    case types.RATING_REMOVE_ALL_FIELDS:
      return immutable.set(state, 'rating', defaultState.rating);

    case types.RATING_REMOVE_NON_HEADER_FIELDS: {
      const headerFields = [
        'submitterName',
        'submitterTeam',
        'driverName',
        'series',
        'track',
        'date',
        'startPos',
        'finishPos',
        'submitted',
      ];
      const headerState = _.pick(state.rating.fields, headerFields);
      return immutable.set(state, 'rating.fields', headerState);
    }

    default:
      return state;
  }
};
